import { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { matchPath, useLocation } from 'react-router-dom';
import { StorageKey, LanguageCode } from './languageConstants';

export const useSwitchLanguage = () => {
  const { i18n } = useTranslation();
  const storedLanguage = localStorage.getItem(StorageKey.languageCode) || LanguageCode.EN_LNG_CODE;
  const [lngCode, setLngCode] = useState(storedLanguage);
  const location = useLocation();

  // Set local storage on a manual change
  useEffect(() => {
    i18n.changeLanguage(lngCode);
    localStorage.setItem(StorageKey.languageCode, lngCode);
    const storageEvent = new StorageEvent('storage', {
      key: StorageKey.languageCode,
      newValue: lngCode,
    });
    window.dispatchEvent(storageEvent);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lngCode]);

  // Create a listener that only cares about language changes
  const languageListener = useCallback(
    ({ key, newValue }: StorageEvent) => {
      if (key == StorageKey.languageCode) {
        setLngCode(newValue);
      }
    },
    [lngCode],
  );

  // Use our language listener
  useEffect(() => {
    window.addEventListener('storage', languageListener);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Force reset language if we navigate away from case-check
  useEffect(() => {
    const match = matchPath(location.pathname, {
      path: '*/case-check*',
    });
    if (!match) {
      setLngCode(LanguageCode.EN_LNG_CODE);
    }
  }, [location]);

  return { lngCode, setLngCode };
};
